module.exports = __webpack_public_path__ + "static/media/koffie.7d717f70.png";